var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MatPaginatorIntl } from '@angular/material';
import * as i0 from "@angular/core";
var PaginatorIntlService = /** @class */ (function (_super) {
    __extends(PaginatorIntlService, _super);
    function PaginatorIntlService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemsPerPageLabel = 'Items per page';
        _this.nextPageLabel = 'Next page';
        _this.previousPageLabel = 'Previous page';
        _this.getRangeLabel = function (page, pageSize, length) {
            var of = this.translate
                ? this.translate.instant('Global.Paginator.Of')
                : 'of';
            if (length === 0 || pageSize === 0) {
                return '0 ' + of + ' ' + length;
            }
            length = Math.max(length, 0);
            var startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            var endIndex = startIndex < length
                ? Math.min(startIndex + pageSize, length)
                : startIndex + pageSize;
            return startIndex + 1 + ' - ' + endIndex + ' ' + of + ' ' + length;
        };
        return _this;
    }
    PaginatorIntlService.prototype.injectTranslateService = function (translate) {
        var _this = this;
        this.translate = translate;
        this.translate.onLangChange.subscribe(function () {
            _this.translateLabels();
        });
        this.translateLabels();
    };
    PaginatorIntlService.prototype.translateLabels = function () {
        this.itemsPerPageLabel = this.translate.instant('Global.Paginator.ItemsPerPage');
        this.nextPageLabel = this.translate.instant('Global.Paginator.NextPage');
        this.previousPageLabel = this.translate.instant('Global.Paginator.PreviousPage');
    };
    PaginatorIntlService.ngInjectableDef = i0.defineInjectable({ factory: function PaginatorIntlService_Factory() { return new PaginatorIntlService(); }, token: PaginatorIntlService, providedIn: "root" });
    return PaginatorIntlService;
}(MatPaginatorIntl));
export { PaginatorIntlService };
